import { getConfirmationConfig } from 'checkout/selectors/ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Confirmation from '../components/Confirmation';
import ContainerProps from './ConfirmationContainerComponent';
import { createLoadingSelector } from '../../../selectors/helpers'

class ConfirmationContainer extends Component<ContainerProps> {
    render() {
        return(
            <Confirmation
                confirmationNumber={this.props.confirmationNumber}
                email={this.props.email}
                events={this.props.events}
                uiConfig={this.props.uiConfig}
                ticketsUrl={this.props.ticketsUrl}
                content={this.props.content}
                displaySocial={this.props.displaySocial}
                queueOn={this.props.queueOn}
                queueIt={this.props.queueIt}
                onClickShareTwitter={this.onClickShareTwitter}
                onClickShareFacebook={this.onClickShareFacebook}
                facebookAppId={this.props.facebookAppId}
                livestreamData={this.props.livestreamData}
                baseUrl={this.props.baseUrl}
                listingSlug={this.props.listingSlug}
                pending={this.props.reservationPending}
                isEmbed={this.props.isEmbed}
                isFetching={this.props.isFetching}
            />
        )
    }

    onClickShareTwitter = () => {
        const popupWidth = 550;
        const popupHeight = 285;
        const left = (screen.width/2)-(popupWidth/2);
        const top = (screen.height/2)-(popupHeight/2);
        const url = "https://twitter.com/intent/tweet?source=tweetbutton&text=" + encodeURIComponent(this.props.twitterMessage);

        window.open(url, 'Twitter', 'width=' + popupWidth + 'px,height=' + popupHeight + 'px,resizable=1,top=' + top + ',left=' + left);
    }

    onClickShareFacebook = () => {
        if (typeof FB !== 'undefined') {
            FB.ui({
                method: 'share',
                href: this.props.socialLink,
            }, function(response){});
        }
    }
}

const reservationLoadingSelector = createLoadingSelector(['RESERVATION_FETCH']);

const mapStateToProps = state => {
    let confirmationConfig = getConfirmationConfig(state);
    let content = "";
    if(confirmationConfig.content) {
        content = confirmationConfig.content;
    }
    return {
        deliveryMethodName: state.confirmation.deliveryMethodName,
        confirmationNumber: state.confirmation.confirmationNumber,
        email: state.member.email,
        listingSlug: state.ui.listingSlug,
        ticketsUrl: state.confirmation.ticketsUrl,
        content,
        queueOn: state.ui.uiConfig.queueOn,
        queueIt: state.ui.uiConfig.queueIt,
        displaySocial: state.socialSettings.displaySocial,
        socialLink: state.socialSettings.socialLink,
        twitterMessage: state.socialSettings.twitterMessage,
        facebookAppId: state.socialSettings.facebookAppId,
        livestreamData: state.livestream.streamData,
        reservationPending: !!state.reservation?.isPendingPaymentCompletion,
        isEmbed: !!state.ui.isEmbed,
        isFetching: reservationLoadingSelector(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

ConfirmationContainer.propTypes = {
    confirmationNumber: PropTypes.string,
    email: PropTypes.string,
    events: PropTypes.arrayOf(PropTypes.object),
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationContainer)
